import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Input } from 'antd';
import { Captcha, captchaSettings } from 'reactjs-captcha';
import Button from 'components/Button';
import { InputContain, LabelDefault } from 'components/InputText/styles';
import { getEnv } from 'config/enviroment';
import { validarCaptcha } from './captcha';

const env = getEnv();

captchaSettings.set({
  captchaEndpoint: env.URL_CAPTCHA,
});

const CaptchaComponent = ({ onValidade, onSendCaptcha, buttonLabel }) => {
  const unitaryTests = useSelector(state => state.app.unitaryTests);
  const captchaStore = useSelector(state => state.app.captcha);

  const [captcha, setCaptcha] = useState(null);
  const [validation, setValidation] = useState(null);
  const [valueCaptcha, setValueCaptcha] = useState('');

  useEffect(() => {
    if (captchaStore?.reload) captcha?.reloadImage();
  }, [captcha, captchaStore]);

  const validaCaptcha = () => {
    validarCaptcha(captcha, onValidade, setValidation, setValueCaptcha, onSendCaptcha);
  };

  return (
    <>
      {!unitaryTests && <Captcha captchaStyleName="fasCaptcha" ref={captcha => setCaptcha(captcha)} />}

      <br />
      <InputContain>
        <Input
          id="fasCaptchaUserInput"
          data-testid="formCaptcha"
          type="text"
          placeholder="Digite o Código"
          value={valueCaptcha}
          onChange={e => setValueCaptcha(e.target.value)}
        />
        <LabelDefault>{validation}</LabelDefault>
      </InputContain>
      <br />
      <Button data-testid="buttonCaptcha" text={buttonLabel} clickAction={validaCaptcha} />
    </>
  );
};

CaptchaComponent.propTypes = {
  onValidade: PropTypes.func,
  onSendCaptcha: PropTypes.func,
  buttonLabel: PropTypes.string,
};

export default CaptchaComponent;
